document.addEventListener("DOMContentLoaded", function() {

  var bannedWords = [
    /([rR®ℝ][oO0øöο°][bBß6][lL|!][oO0øöο°][xX×✗])/u,
    /[fFƒ][rR®ℝ][eE3€ëé][eE3€ëé][\s\-_.]*[fFƒ][iI1!|][rR®ℝ][eE3€ëé]/u,
    /[follando]|[sexo]|[SEXO]/u,
  ]

  function attachButtonListener(shadowRoot) {
    var btn = shadowRoot.querySelector('[data-spec="message-submit"]');
    if (!btn || btn._listenerAttached) return;
    btn._listenerAttached = true;

    btn.addEventListener("click", e => {
      var textarea = shadowRoot.querySelector('textarea');
      var message = textarea ? textarea.value.trim() : "";
      if (hasValidLength(message) && isntEmoji(message) && testRegex(message)) {
        console.log("Mensaje enviado:", message);
      }
      else{
        e.preventDefault();
      }
    });
  }

  // Observer sobre el shadow root del inbox
  function observeShadowRoot(shadowRoot) {
    var shadowObserver = new MutationObserver(function() {
      attachButtonListener(shadowRoot);
    });
    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
  }

  function hasValidLength(message){
    return message.length >= 4;
  }

  function testRegex(message){
    return bannedWords.every(regex => !regex.test(message));
  }

  function isntEmoji(message){
    return !/\p{Extended_Pictographic}/u.test(message);
  }

  // Observer sobre el body para detectar cuando inbox aparece
  var bodyObserver = new MutationObserver(function() {
    var inbox = document.querySelector("inbox-online-store-chat");
    if (!inbox || !inbox.shadowRoot || inbox._observed) return;
    inbox._observed = true;

    // Una vez que inbox existe, observamos su shadow root directamente
    observeShadowRoot(inbox.shadowRoot);
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });

});